import WebProvider from "./WebProvider";

let selectedProvider = null;
let BaseUrl = "";
let ServiceUrl = "";

const appType = window.vidyoApp?.getMode?.() === 0 ? "DESKTOP" : "WEB";

export const getInRoomAnnouncementProvider = () => {
  if (selectedProvider) {
    return selectedProvider;
  }
  switch (appType) {
    case "DESKTOP":
      //selectedProvider = new DesktopProvider(BaseUrl);
      break;

    case "WEB":
      selectedProvider = new WebProvider(BaseUrl, ServiceUrl);
      break;

    default:
      // selectedProvider = new WebProvider();
      break;
  }

  return selectedProvider;
};

export const setURL = (url, serviceUrl) => {
  BaseUrl = url;
  ServiceUrl = serviceUrl;
};
